import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useListings = () => {
  const [listings, setListings] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/listings`)
      .then((r) => setListings(r.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return { listings, loaded };
};
